import { FetchAPI } from '../Main/fetchAPI';
import { CLIENT } from '../constants';
import { CreateInsuranceProperties, UpdateInsuranceProperties } from './insuranceProperties';
import { GetInsuranceProperties } from './insuranceAuthorizationProperties';

export const Insurances = {
	getInsurances: ({ includeOutOfNetwork }: GetInsuranceProperties) => {
		const query = new URLSearchParams();
		if (typeof includeOutOfNetwork === 'boolean') query.set('includeOutOfNetwork', `${includeOutOfNetwork}`);

		return FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances?${query.toString()}`,
		});
	},
	getInsurancesForAdmin: (data: GetInsuranceProperties) => {
		const query = new URLSearchParams();
		const { searchString, includeOutOfNetwork } = data;
		if (searchString) query.set('searchString', searchString);
		if (typeof includeOutOfNetwork === 'boolean') query.set('includeOutOfNetwork', `${includeOutOfNetwork}`);

		return FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/admin?${query.toString()}`,
		});
	},

	getInsuranceById: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/${id}`,
		}),

	createInsurance: (data: CreateInsuranceProperties) =>
		FetchAPI.postJson({
			urlStr: `${CLIENT}/insurances`,
			data,
		}),

	updateInsurance: (data: UpdateInsuranceProperties) =>
		FetchAPI.putJson({
			urlStr: `${CLIENT}/insurances/${data.id}`,
			data,
		}),

	getInsuranceBranches: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/${id}/branches`,
		}),

	getInsuranceClients: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/${id}/clients`,
		}),

	getInsuranceUsers: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/${id}/users`,
		}),
	getInsuranceLocations: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/insurances/${id}/locations`,
		}),
};
